import PropTypes from 'prop-types';

export default {
	content: PropTypes.string,
	id: PropTypes.number,
	name: PropTypes.string,
	version: PropTypes.number
}